import type { HttpInterceptorFn } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionStore } from '@app/core/session/session-store';
import { environment } from '@env/environment';
import { RENEWS_SESSION, REQUIRE_AUTH, SILENT_REQUEST } from '@shared/utils/http-context.util';
import { tap } from 'rxjs/operators';

export const RENEWED_TOKEN_HEADER = 'X-Access-Token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isAuthRequired = req.context.get(REQUIRE_AUTH);

  const isOwnApi = req.url.startsWith(environment.urlApiPlatform) || req.url.startsWith('/') || req.url.startsWith('./') || req.url.startsWith('../');

  if (!isAuthRequired || !isOwnApi) {
    return next(req);
  }

  const sessionStore = inject(SessionStore);
  const token = sessionStore.getToken();

  const setHeaders: Record<string, string> = { Accept: 'application/json' };

  if (token) {
    setHeaders['Authorization'] = `Bearer ${token}`;
  }

  const hasBody = req.method !== 'GET' && req.body != null;

  if (hasBody && !(req.body instanceof FormData)) {
    setHeaders['Content-Type'] = 'application/json';
  }

  const mayRenewTheSession = !req.context.get(SILENT_REQUEST) || req.context.get(RENEWS_SESSION);

  return next(req.clone({ setHeaders })).pipe(
    tap(event => {
      if (mayRenewTheSession && event instanceof HttpResponse) {
        sessionStore.applyRenewedToken(event.headers.get(RENEWED_TOKEN_HEADER));
      }
    }),
  );
};
